import { useCallback } from "react"
import { useLocation } from "react-router"
import type { ExtraCostsPriceBreakdownPricingFormInputProps } from "src/components"
import { ExtraCostsPriceBreakdownPricingForm } from "src/components"
import { getVehicleDetailsAnalyticsPage, trackEvent } from "src/components/adobeAnalytics"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { useCalculatedPriceBreakdown } from "./useCalculatedPriceBreakdown"

export const ExtraCostsPriceBreakdownPricingFormContainer = withErrorHandler(
	({ fields, formattedMsrp, inventoryId, priceHistory }: ExtraCostsPriceBreakdownPricingFormInputProps) => {
		const calculatedPriceBreakdown = useCalculatedPriceBreakdown(inventoryId)
		const { pathname } = useLocation()
		const analyticsPage = getVehicleDetailsAnalyticsPage(pathname, "overview")
		const trackExtraCostToggle = useCallback(
			(isChecked: boolean) => {
				trackEvent({
					action: isChecked ? "check_add_dealer_fee" : "check_remove_dealer_fee",
					category: analyticsPage,
				})
			},
			[analyticsPage],
		)

		return (
			<ExtraCostsPriceBreakdownPricingForm
				calculatedPriceBreakdownView={calculatedPriceBreakdown}
				fields={fields}
				formattedMsrp={formattedMsrp}
				onExtraCostToggle={trackExtraCostToggle}
				priceHistory={priceHistory}
			/>
		)
	},
)
